module.exports = __webpack_public_path__ + "assets/img/qrCode.64dee846.png";